/**
 * Avalara © 2017
 * file: engines/opus_ui/src/search/SearchBar.js
 */

import React, { Component } from 'react';
import './SearchBar.css';
import { connect } from 'react-redux';
import blueSearchIcon from '../assets/bluesearch.png';

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: this.props.query,
      searchHandler: this.props.handleSearch,
    };

    // This binding is necessary to make `this` work in the callback
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleQueryStringChange = this.handleQueryStringChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ query: nextProps.query });
  }

  handleSearch(input) {
    if (this.state.searchHandler) this.props.handleSearch(this, input);
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleSearch(e.target);
    }
  }

  handleQueryStringChange(e) {
    this.setState({ query: e.target.value });
  }

  render() {
    const query = this.state.query;
    return (
      <div className="SearchBar">
        <input
          ref={(input) => {
            input && (this.searchInput = input) && input.focus();
          }}
          className="SearchBox"
          placeholder="Search string ..."
          onKeyPress={this.handleKeyPress}
          value={query}
          onChange={this.handleQueryStringChange}
        />
        <img
          src={blueSearchIcon}
          alt="Search Icon"
          className="SearchButton"
          onClick={() => {
            this.handleSearch(this.searchInput);
          }}
        />
      </div>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(SearchBar);
